export const createProductId = ({
  periodName,
  periodQuantity,
  price,
}: {
  periodName: string
  periodQuantity: number | null
  price: number
}) => `mygrowth_${periodQuantity}_${periodName}_${price}`
